import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

// serviceOption- 0: , 1: Premium Service, 2: Standard Service, 3: LCO, 4: Load n Go, 5: Load n Go w/o
// servicePriority- 0: , 1: Same Day, 2: Next Day
// consensusSequence- 0: , 1: Yes, 2: No
const initialState = {
  page: 0,
  data: {
    orderNumber: "",
    orderDate: "",
    orderForm: 25,
    orderStatus: 1,
    serviceOption: "",
    servicePriority: 0,
    sampleAmount: "",
    otherComments: "",
    tableData: [],
    dropBoxId: null,
    dropBoxDate: "",
    consensus: 2,
    templateBanking: 0,
    orderAmount: 0,
	orderItemLists: [],
	selectedWpsOrderNumber:'',
	discountId: null
  },
  billingInformation: {
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    email: "",
    shippingOption: "Dropbox",
    dropboxLocation: "",
    dropoffDate: "",
    billingMethod: "",
    purchasingAgentName: "",
    purchasingAgentEmail: "",
    poNumber: "",
    grantNumber:"",
    grantPi:"",
    grantNote:"",
    ccNumber: "",
    ccMonth: "",
    ccYear: "",
    cvv: "",
	ccZip: "",
    cardType: "",
    ccName: "",
    acgtCard: "",
  },
  primer: {
    primerList: [],
    primerAmount: "",
    banking: 0,
    comments: "",
    primerSynthesisList: [],
    synthesis: 0,
  },
};

const sppeFormSlice = createSlice({
  name: "sppeorderform",
  initialState,
  reducers: {
    //action creators
    initializeSppeTableData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newObj = {
          id: i + 1,
          dName: "",
          dConc: 0,
          dType: "",
          pcrSize: 0,
          library: "",
          pName: "",
          pConc: 0,
          pbp: false,
          alt: "",
          orderId: 0,
        };
        state.data.tableData.push(newObj);
      }
      return;
    },
    resetSppeState(state, action) {
      Object.assign(state, initialState);
      return;
    },
    resetSppeTableData(state, action) {
      state.data.tableData = action.payload;
      return;
    },
    setSppeSampleAmount(state, action) {
      state.data.sampleAmount = parseInt(action.payload);
      return;
    },
    setSppeServiceOption(state, action) {
      state.data.serviceOption = action.payload;
      return;
    },
    clearSppeServiceOption(state, action) {
      state.data.serviceOption = action.payload;
      return;
    },
    setSppeServicePriority(state, action) {
      state.data.servicePriority = parseInt(action.payload);
      return;
    },
    setSppeConsensusSequence(state, action) {
      state.data.consensus = parseInt(action.payload);
      return;
    },
    addSppeRow: (state, action) => {
      const newRow = action.payload;
      // Add the new row to the end of tableData
      state.data.tableData.push(newRow);

      // Reset the indices in the updated tableData
      state.data.tableData = state.data.tableData.map((item, index) => ({
        ...item,
        id: index + 1,
      }));
      state.data.sampleAmount = parseInt(state.data.sampleAmount + 1);
      return;
    },
    copySppeRow: (state, action) => {
      const { index } = action.payload;
      const rowToCopy = state.data.tableData[index];

      // Create a copy of the row with a new id
      const copiedRow = {
        ...rowToCopy,
        id: state.data.tableData.length + 1, // Assign a new id or adjust as needed
      };

      // Insert the copied row at a specific position (e.g., next to the original row)
      state.data.tableData.splice(index + 1, 0, copiedRow);

      // Reset the indices in the updated tableData
      state.data.tableData = state.data.tableData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));
      state.data.sampleAmount = parseInt(state.data.sampleAmount + 1);
      return;
    },
    deleteSppeRow: (state, action) => {
      const { index } = action.payload;
      const updatedTableData = state.data.tableData.filter(
        (item, i) => i !== index
      );

      // Reset the indices in the updated tableData
      const resetIndexedTableData = updatedTableData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));

      // Update the tableData state
      state.data.tableData = resetIndexedTableData;
      state.data.sampleAmount = parseInt(state.data.sampleAmount - 1);
      return;
    },
    editSppeRow(state, action) {
      const { index, value, property } = action.payload;
      let pattern = /^[a-zA-Z0-9-_]{0,20}$/;
      const updatedData = [...state.data.tableData];

      if (property === "dName" || property === "pName") {
        if (pattern.test(value)) {
          updatedData[index][property] = value;
        } else {
          // You may want to handle this case differently, e.g., show an error message
          alert(
            "Only special characters allowed: hyphen( - ) and underscore( _ )."
          );
          return;
        }
      } else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.data.tableData = updatedData;
    },
    increaseSppeConcentration(state, action) {
      const { index, property } = action.payload;
      state.data.tableData[index][property] += 1;
    },
    decreaseSppeConcentration(state, action) {
      const { index, property } = action.payload;
      if (state.data.tableData[index][property] > 0) {
        state.data.tableData[index][property] -= 1;
      }
    },
    clearSppeSelect(state, action) {
      const { index, property } = action.payload;

      state.data.tableData[index] = {
        ...state.data.tableData[index],
        [property]: "", // Set the specified property to an empty string for the specific row
      };

      return;
    },
    toggleSppeCheckbox: (state, action) => {
      const { index, property } = action.payload;
      const newData = [...state.data.tableData];
      newData[index][property] = !newData[index][property];
      state.data.tableData = newData;
    },
    sppePrevStep: (state, action) => {
      state.page = state.page - 1;
    },
    sppeNextStep: (state, action) => {
      state.page = state.page + 1;
    },
    sppeSetStep: (state, action) => {
      state.page = action.payload;
    },
    resetSppePage: (state, action) => {
      state.page = action.payload;
    },
    initializeSppePrimerTableData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newObj = {
          id: i + 1,
          pName: "",
          pSequence: "",
        };
        state.primer.primerSynthesisList.push(newObj);
      }
      return;
    },
    resetSppePrimerTableData(state, action) {
      state.primer.primerSynthesisList = action.payload;
    },
    setSppePrimerAmount(state, action) {
      state.primer.primerAmount = parseInt(action.payload);
      return;
    },
    addSppePrimerRow: (state, action) => {
      const newRow = action.payload;
      // Add the new row to the end of tableData
      state.primer.primerSynthesisList.push(newRow);

      // Reset the indices in the updated tableData
      state.primer.primerSynthesisList = state.primer.primerSynthesisList.map(
        (item, index) => ({
          ...item,
          id: index + 1,
        })
      );
      state.primer.primerAmount = parseInt(state.primer.primerAmount + 1);
      return;
    },
    editSppePrimerRow(state, action) {
      const { index, property, value } = action.payload;
      let pattern = /^[a-zA-Z0-9_-]*$/;
      const updatedData = [...state.primer.primerSynthesisList];

		if (property === "pName") {
			if (pattern.test(value)) {
				updatedData[index][property] = value;
			} else {
			// You may want to handle this case differently, e.g., show an error message
			return;
			}
		} else if (property === "pSequence") {
			let pattern2 = /^[acgtACGT]*$/
			if (pattern2.test(value)) {
				updatedData[index][property] = value;
			} else {
			alert(
				"Primers with degenerate bases cannot be used for Sanger sequencing. Primer sequence must match the template it binds to exactly."
				// "Only characters allowed: A, C, G and T"
			);
				return;
			}
		}  else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.primer.primerSynthesisList = updatedData;
    },
    deleteAllSppePrimer(state, action) {
      state.primer.primerSynthesisList = action.payload;
      state.primer.primerAmount = "";
      return;
    },
    setSppePrimerBanking(state, action) {
      state.primer.banking = action.payload;
      return;
    },
    setSppePrimerList(state, action) {
      const list = action.payload.split(/,\s|\n|,/);
      state.primer.primerList = list;
      // console.log(state.primer.primerList);
      return;
    },
    setSppePrimerSynthesis(state, action) {
      state.primer.synthesis = action.payload;
      return;
    },
    setSppePrimerComments(state, action) {
      state.primer.comments = action.payload;
      return;
    },
    setSppeDropboxLocation(state, action) {
      state.billingInformation.dropboxLocation = action.payload.label;
      return;
    },
    setSppeDropboxId(state, action) {
      state.data.dropBoxId = action.payload;
      return;
    },
    setSppeDropoffDate(state, action) {
      state.billingInformation.dropoffDate = action.payload;
      state.data.dropBoxDate = action.payload;

      // Test the regular expression with a date
      // if (dateRegex.test(result)) {
      // }
    },
    setSppeFirstName(state, action) {
      state.billingInformation.firstName = action.payload;
      return;
    },
    setSppeLastName(state, action) {
      state.billingInformation.lastName = action.payload;
      return;
    },
    setSppeCompany(state, action) {
      state.billingInformation.company = action.payload;
    },
    setSppePhone(state, action) {
      const phoneRegex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
      const result = action.payload;

      // Test the regular expression with a date
      // if (phoneRegex.test(result)) {
      //   state.billingInformation.phone = result;
      // }
      state.billingInformation.phone = result;
    },
    setSppeEmail(state, action) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      state.billingInformation.email = action.payload;
    },
    setSppeShippingOption(state, action) {
      state.billingInformation.shippingOption = action.payload;
      return;
    },
    setSppeAcgtCard(state, action) {
      state.billingInformation.acgtCard = action.payload;
      return;
    },
    setSppeCCNumber(state, action) {
      state.billingInformation.ccNumber = action.payload;
      return;
    },
    setSppeCCMonth(state, action) {
      state.billingInformation.ccMonth = action.payload;
      return;
    },
    setSppeCCYear(state, action) {
      state.billingInformation.ccYear = action.payload;
      return;
    },
    setSppeCVV(state, action) {
      state.billingInformation.cvv = action.payload;
      return;
    },
	setSppeCCZip(state, action) {
      state.billingInformation.ccZip = action.payload;
      return;
    },
    setSppeCCName(state, action) {
      state.billingInformation.ccName = action.payload;
      return;
    },
    setSppeCardType(state, action) {
      state.billingInformation.cardType = action.payload;
      return;
    },
    setSppeBillingMethod(state, action) {
      state.billingInformation.billingMethod = action.payload;
      return;
    },
    setSppePurchasingAgentName(state, action) {
      state.billingInformation.purchasingAgentName = action.payload;
      return;
    },
    setSppePurchasingAgentEmail(state, action) {
      state.billingInformation.purchasingAgentEmail = action.payload;
      return;
    },
    setSppePoNumber(state, action) {
      state.billingInformation.poNumber = action.payload;
      return;
    },
    setSppeGrantNumber(state, action) {
      state.billingInformation.grantNumber = action.payload;
      return;
    },
    setSppeGrantPI(state, action) {
      state.billingInformation.grantPi = action.payload;
      return;
    },
    setSppeGrantNote(state, action) {
      state.billingInformation.grantNote = action.payload;
      return;
    },
    setSppeOrderNumber(state, action) {
      state.data.orderNumber = action.payload
    },
    setSppeOrderAmount(state, action) {
      state.data.orderAmount = action.payload
	},
	setSppeOrderDiscount(state, action) {
		state.data.discountId = action.payload
	},
	setSelectedWpsOrderNumber(state, action) {
		state.data.selectedWpsOrderNumber = action.payload
	}
  },
  //tell our combined reducer to look for additional action types
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return [];
    });
  },
});

export const {
  setSppeShippingOption,
  setSppePoNumber,
  setSppeGrantNumber,
  setSppeGrantPI,
  setSppeGrantNote,
  setSppeOrderNumber,
  setSppeOrderAmount,
  setSppeOrderDiscount,
  setSppeCardType,
  setSppeCCName,
  setSppePurchasingAgentEmail,
  setSppePurchasingAgentName,
  setSppeCCNumber,
  setSppeCCMonth,
  setSppeCCYear,
  setSppeCVV,
  setSppeCCZip,
  setSppeBillingMethod,
  resetSppeTableData,
  setSppeAcgtCard,
  setSppeEmail,
  setSppeCompany,
  setSppePhone,
  setSppeFirstName,
  setSppeLastName,
  setSppeDropoffDate,
  increaseSppeConcentration,
  decreaseSppeConcentration,
  initializeSppeTableData,
  resetSppePrimerTableData,
  setSppeServiceOption,
  setSppeServicePriority,
  setSppeSampleAmount,
  addSppeRow,
  resetSppeState,
  editSppeRow,
  deleteSppeRow,
  copySppeRow,
  toggleSppeCheckbox,
  sppePrevStep,
  sppeNextStep,
  sppeSetStep,
  resetSppePage,
  editSppePrimerRow,
  addSppePrimerRow,
  setSppePrimerAmount,
  initializeSppePrimerTableData,
  deleteAllSppePrimer,
  setSppeConsensusSequence,
  setSppePrimerBanking,
  setSppePrimerList,
  setSppePrimerSynthesis,
  setSppePrimerComments,
  clearSppeSelect,
  clearSppeServiceOption,
  setSppeDropboxLocation,
  setSppeDropboxId,
  setSelectedWpsOrderNumber,
} = sppeFormSlice.actions;
export const sppeFormReducer = sppeFormSlice.reducer;
